<template>
    <div> 
        <PlanoInfo/>
        <ResultadoPrestador/>
        <ResultadoProfissionais/>
    </div>
</template>

<script>
    import ResultadoPrestador from '../components/ResultadoPrestador.vue';
    import ResultadoProfissionais from '../components/ResultadoProfissionais.vue';
    import PlanoInfo from '../components/planoInfo.vue';
    import { mapState } from "vuex";
    
    export default {
        computed: {
            ...mapState(['scrollHandler', 'statusLoadingRoute'])
        },
        components: {
            ResultadoPrestador,
            ResultadoProfissionais,
            PlanoInfo
        },

    }
</script>